import { Field, withFormik, getIn } from 'formik';
import React, { useEffect, useState } from 'react';
import { Accordion, Card, Col, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { InputSelect, FormikDatePicker, FormikSelect } from '../../components';
import { debounceIndexEmployeesRequest } from '../../requests/employees';
import { indexTerminationReasonsRequest } from '../../requests/terminationReasons';

const Filters = props => {
  const { setFieldValue, values, errors, touched } = props;
  const dispatch = useDispatch();
  const [terminationReasons, setTerminationReasons] = useState([]);

  const fetchEmployees = (inputValue, callback) => {
    debounceIndexEmployeesRequest({
      dispatch,
      params: {
        active: true,
        filter_name: inputValue,
        sort_column: 'name',
        is_dt: false,
        display_length: 100
      },
      successCallback: response => {
        callback(response.data.data);
      }
    });
  };

  const handleNewMulti = (data, field, allowEmpty = false) => {
    const newData = data.map(element => element.value);
    if (allowEmpty && !newData.length) newData.push('');
    setFieldValue(field, newData);
  };

  const handleSuccessTermination = ({ data }) => {
    setTerminationReasons(data.data);
  };

  const fetchTerminationReasons = () => {
    indexTerminationReasonsRequest({
      dispatch,
      params: {
        paginate: false
      },
      successCallback: handleSuccessTermination,
      callback: () => {}
    });
  };

  useEffect(fetchTerminationReasons, []);

  return (
    <Accordion defaultActiveKey="1" className="col-12 p-0 mb-4">
      <Col className="top-header-green settlement__filters">
        <Accordion.Toggle as={Col} eventKey="0" className="card-header-title justify-content-center">
          FILTROS DE BÚSQUEDA
        </Accordion.Toggle>
      </Col>
      <Accordion.Collapse eventKey="0">
        <Card.Body className="div-content">
          <Row>
            <Col xs={12} md={3}>
              <Field name="startDate">
                {({ field }) => (
                  <FormikDatePicker
                    {...field}
                    abbr
                    isOutsideRange={() => false}
                    label="Periodo (Fecha de Inicio)"
                    placeholder="dd/mm/aaaa"
                    onDateChange={date => {
                      setFieldValue(field.name, moment.isMoment(date) ? date.format('DD/MM/YYYY') : '');
                    }}
                    error={getIn(errors, field.name)}
                    touched={getIn(touched, field.name)}
                  />
                )}
              </Field>
            </Col>
            <Col xs={12} md={3}>
              <Field name="employees">
                {({ field }) => (
                  <InputSelect
                    {...field}
                    label="Colaboradores"
                    isMulti
                    placeholder="Seleccione colaboradores"
                    values={values.filterEmployeeIds}
                    request={fetchEmployees}
                    onChange={data => {
                      handleNewMulti(data || [], 'filterEmployeeIds', true);
                      setFieldValue(field.name, data || []);
                    }}
                    error={getIn(errors, field.name)}
                    touched={getIn(touched, field.name)}
                  />
                )}
              </Field>
            </Col>
            <Col xs={12} md={3}>
              <Field name="terminationReason">
                {({ field }) => (
                  <FormikSelect
                    {...field}
                    abbr
                    label="Causal de Término Contrato"
                    placeholder="Causal de Término Contrato"
                    options={terminationReasons}
                    value={values?.terminationReason}
                    defaultValue={values?.terminationReason}
                    onChange={data => setFieldValue(field.name, data ? data.value : '')}
                    error={getIn(errors, field.name)}
                    touched={getIn(touched, field.name)}
                  />
                )}
              </Field>
            </Col>
          </Row>
        </Card.Body>
      </Accordion.Collapse>
    </Accordion>
  );
};

const handleSubmit = (values, { props }) => {
  const { formRequest } = props;
  formRequest(values);
};

export default withFormik({
  mapPropsToValues: () => ({
    startDate: '',
    filterJobManagement: '',
    filter_branch_offices: '',
    filterCostCenter: '',
    filterBalanceIds: '',
    filterPeriodType: '',
    filterEmployeeIds: [],
    terminationReason: ''
  }),
  handleSubmit,
  enableReinitialize: true
})(Filters);
